<jqxLoader #loader [imagePosition]="'top'" [width]="100" [height]="60" [text]="translate('Procesando')">
</jqxLoader>
<div class="menu-container" #menuContainer>
  <jqxMenu #menu [theme]="environment.tema" [mode]="'vertical'" [width]="'100%'" [height]="'100%'"
    [popupZIndex]="2147483647" [autoCloseOnMouseLeave]="false" [autoCloseOnClick]="false"
    (onItemclick)="onItemClick($event)" [autoOpen]="false" style="border: hidden;">
  </jqxMenu>
</div>
